import { ApiClient } from "../config/axiosConfig";
import { IPaginatedResponse } from "../models/Pagination";
import {
  DhlTrackingResponse,
  FedexTrackingResponse,
  IAwb,
  IAwbAddStatus,
  IAwbDetail,
  ICreateShipmentInfo,
  IFilterAwb,
  IParamFilterShipment,
  IShipmentInfo,
  IUpdateShipmentInfo,
} from "../models/Tracking";

export const TrackingService = {
  tracking: async (trackingNumber: string) => {
    const res = await ApiClient.GET<DhlTrackingResponse>(
      `/tracking/${trackingNumber}`
    );
    return res;
  },
  trackings: async (trackingNumbers: string[]) => {
    const res = await ApiClient.POST<DhlTrackingResponse[]>(`/tracking/bulk`, {
      trackingNumbers,
    });
    return res;
  },
};

export const FedexTrackingService = {
  tracking: async (trackingNumber: string) => {
    const res = await ApiClient.GET<FedexTrackingResponse>(
      `/fedex-tracking/${trackingNumber}`
    );
    return res;
  },
};
export const ShipmentService = {
  shipmentInfo: async (params: IParamFilterShipment) => {
    const res = await ApiClient.GET<IPaginatedResponse<IShipmentInfo>>(
      `/shipments`,
      params
    );
    return res;
  },
  createShipment: async (data: ICreateShipmentInfo[]) => {
    const res = await ApiClient.POST<IShipmentInfo[]>(`/shipments`, data);
    return res;
  },
  updateShipment: async (id: number, data: IUpdateShipmentInfo) => {
    const res = await ApiClient.PATCH<IShipmentInfo>(`/shipments/${id}`, data);
    return res;
  },
};
export const AwbService = {
  getAwb: async (params: IFilterAwb) => {
    const res = await ApiClient.GET<IPaginatedResponse<IAwb>>(`/awbs`, params);
    return res;
  },
  getAwbById: async (id: number) => {
    const res = await ApiClient.GET<IAwbDetail>(`/awbs/${id}`);
    return res;
  },
  getAwbByCode: async (awbCode: string) => {
    const res = await ApiClient.GET<IAwbDetail>(`/awbs/${awbCode}/awbCode`);
    return res;
  },
  addAwbStatus: async (data: IAwbAddStatus) => {
    const res = await ApiClient.POST<IAwbDetail>(`/awbs/status`, data);
    return res;
  },
  updateAwbStatus: async (awbCode: string) => {
    const res = await ApiClient.POST<IAwbDetail>(`/awbs/update`, { awbCode });
    return res;
  },
};
